<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Pengguna</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'adminUserCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>
                
                <h4 class="page-title">
                    <router-link :to="{ name: 'adminUser' }">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Pengguna
                </h4>
            </div>
        </div>
    </div>

    <div>
        <form @submit.prevent="submitForm()" autocomplete="off">
             <div class="card">
                <div class="card-body">
                    <div class="form-group" :class="{ 'is-invalid': $v.dataUser.name.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Nama</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama" 
                        v-model.trim="$v.dataUser.name.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataUser.name.required">Nama wajib diisi</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataUser.email.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Email</label>
                        <input type="text" class="form-control" placeholder="Masukkan Email" 
                        v-model.trim="$v.dataUser.email.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataUser.email.required">Email wajib diisi</div>
                        <div class="error" v-if="!$v.dataUser.email.email">Email tidak valid</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataUser.username.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Username</label>
                        <input type="text" class="form-control" placeholder="Masukkan Username" 
                        v-model.trim="$v.dataUser.username.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataUser.username.required">Username wajib diisi</div>
                        <div class="error" v-if="!$v.dataUser.username.username">Username tidak boleh berisi spasi atau simbol</div>
                    </div>

                    <div class="form-check form-group" v-if="this.$route.name == 'adminUserEdit'">
                        <input class="form-check-input" type="checkbox" v-model="is_password_edit" id="defaultCheck1">
                        <label class="form-check-label" for="defaultCheck1" style="margin-top: 1px;">
                            Apakah anda ingin mengedit password ?
                        </label>
                    </div>

                    <div v-if="is_password_edit">
                        <div class="form-group" :class="{ 'is-invalid': $v.dataUser.password.$error }">
                            <label for="select-2-form" class="col-form-label text-left d-block">Kata Sandi</label>
                            <input type="password" class="form-control" placeholder="Masukkan Kata Sandi" 
                            v-model.trim="$v.dataUser.password.$model"
                            :disabled="loading">
                            <div class="error" v-if="!$v.dataUser.password.required">Kata Sandi wajib diisi</div>
                            <div class="error" v-if="!$v.dataUser.password.password">Kata Sandi harus terdiri dari minimal 8 karakter huruf besar, huruf kecil, angka dan symbol. karakter </div>
                        </div>

                        <div class="form-group" :class="{ 'is-invalid': $v.dataUser.password_confirmation.$error }">
                            <label for="select-2-form" class="col-form-label text-left d-block">Konfirmasi Kata Sandi</label>
                            <input type="password" class="form-control" placeholder="Masukkan Konfirmasi Kata Sandi" 
                            v-model.trim="$v.dataUser.password_confirmation.$model"
                            :disabled="loading">
                            <div class="error" v-if="!$v.dataUser.password_confirmation.required">Konfirmasi kata sandi wajib diisi</div>
                            <div class="error" v-if="!$v.dataUser.password_confirmation.sameAs">Konfirmasi kata sandi harus sama dengan form diatas</div>
                            <div class="error" v-if="!$v.dataUser.password_confirmation.password">Konfirmasi kata Sandi harus terdiri dari minimal 8 karakter huruf besar, huruf kecil, angka dan symbol. karakter </div>
                        </div>
                    </div>
                </div>
            </div>


            <button class="btn btn-success waves-effect waves-light mb-5" :disabled="loading">
                Simpan Pengguna
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>

            <br>
        </form>
    </div>

  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import { required, sameAs, minLength, email, helpers } from 'vuelidate/lib/validators'
    const username = helpers.regex('username', /^[a-z0-9_]*$/)
    const passwordRegex = helpers.regex('password', /^(?=.*[!@#$%^&*-])(?=.*[0-9])(?=.*[A-Z]).{8,20}$/)

    export default {
        data() {
            return {
                loading: false,
                is_password_edit: this.$route.name == 'adminUserEdit' ? false : true,
                dataUser: {
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                },
            };
        },
        validations() {
            if(!this.is_password_edit && this.$route.name == 'adminUserEdit') {
                return {
                    dataUser: {
                        name: {
                            required,
                        },
                        username: {
                            required,
                            username
                        },
                        email: {
                            required,
                            email
                        }
                    }
                }
            }else{
                return {
                    dataUser: {
                        name: {
                            required,
                        },
                        username: {
                            required,
                            username
                        },
                        email: {
                            required,
                            email
                        },
                        password: {
                            required,
                            passwordRegex,
                        },
                        password_confirmation: {
                            required,
                            sameAsPassword: sameAs('password'),
                            passwordRegex,
                        }
                    }
                }
            }
        },
        methods: {
            // SUBMIT FORM
            submitForm() {
                // IF VALIDATION INVALID
                if (this.$v.dataUser.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess, storedData
                if(this.$route.name == 'adminUserCreate') {
                    url = `auth/administrator/register`
                    method = 'POST',
                    alertSuccess = 'Berhasil membuat pengguna baru!'
                    storedData = {
                        name: this.dataUser.name,
                        username: this.dataUser.username,
                        email: this.dataUser.email,
                        password: this.dataUser.password,
                        password_confirmation: this.dataUser.password_confirmation
                    }
                }else{
                    url = `auth/administrator/update/${this.$route.params.id}`
                    method = 'PUT',
                    alertSuccess = 'Berhasil mengupdate pengguna!'
                    if(this.is_password_edit){
                        storedData = {
                            name: this.dataUser.name,
                            username: this.dataUser.username,
                            email: this.dataUser.email,
                            password: this.is_password_edit ? this.dataUser.password : null,
                            password_confirmation: this.is_password_edit ? this.dataUser.password_confirmation : null
                        }
                    }else{
                        storedData = {
                            name: this.dataUser.name,
                            username: this.dataUser.username,
                            email: this.dataUser.email
                        }
                    }
                    
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: storedData,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    const result = response.data;
                    
                    if(result.success) {
                        this.sAlert('success', alertSuccess)
                        this.$router.push({ name: 'adminUser' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                    this.sAlert('error', error.response.data.message)
                });
            }
        },
        mounted() {
            // LOAD DATA IF ROUTE IS EDIT
            if(this.$route.name == 'adminUserEdit'){
                this.loadingInitial = true
                // LOAD DATA
                this.$http.get(`${this.API_URL}auth/administrator/show/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;
                    
                    if(result.success) {
                        this.dataUser.name = result.data.name
                        this.dataUser.username = result.data.username
                        this.dataUser.email = result.data.email
                    }else {
                        this.sAlert('error', result.message)
                    }

                    this.loading = false;
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        }
    }
</script>